import { useEffect, useState } from "react";
import APIS from "../../constant/EndPoint";
import usePostHook from "../../customHooks/usePostHook";
import Spinner from "../Reusable/Spinner";
import useGetHook from "../../customHooks/useGetHook";
//@ts-ignore
import { tw } from "@careinfo/tailwind";
import { queryClient } from "../../router";
import { useDebounce } from "../../customHooks/useDebounceHook";
import { useSearchParams } from "react-router-dom";
const CargoBranchChargeTable = (props: any) => {
  const {
    localServiceBranch,
    localServiceType,
    localProductType = [],
    branchId,
    id,
  } = props;

  const Product_type = localProductType
    ?.map((item: any) => item?.value)
    ?.join(",");
  const [searchParams, setSearchParms] = useSearchParams({
    searchQuery: "",
  });
  const searchQuery = searchParams.get("searchQuery");
  const debounceSearch = useDebounce(searchQuery);
  const {
    data: branchChargeData,
    isLoading: DeliveryChargeLoading,
    isRefetching,
  } = useGetHook({
    queryKey: [
      "branch-charge",
      `branch-charge-${localServiceBranch}-${localServiceType}-${Product_type}-${debounceSearch}-${id}`,
    ],
    url: APIS.CARGO_BRANCH_CHARGE,
    params: {
      branch: localServiceBranch,
      localServiceType: localServiceType,
      product_type: localProductType
        ?.map((item: any) => item?.value)
        ?.join(","),
      delivery_charge_template: id,
      search: debounceSearch,
    },
  });

  const { mutateAsync, isPostLoading } = usePostHook({
    queryKey: [
      "branch",
      `branch-${localServiceBranch}-${localServiceType}-${Product_type}-${debounceSearch}-${id}`,
    ],
    navigateURL: ``,
  });

  const handleBranchChargeChange = async (
    destination_city: string,
    product_type: string,
    amount: string,
    weightRange: any
  ) => {
    const url = `${APIS.BRANCH_CHARGE}`;
    let formData = {
      delivery_charge_template: id,
      pickup_branch: localServiceBranch,
      destination_city: destination_city,
      service_type: localServiceType,
      product_type: product_type,
      amount: amount,
      weight_range: weightRange,
    };

    try {
      const res = await mutateAsync({ url, formData });
    } catch (err) {
      console.log(err);
    }
  };

  const [rerender, setRerender] = useState(true);

  const handleSearch = (value) => {
    searchParams.set("searchQuery", value);
    setSearchParms(searchParams);
  };

  useEffect(() => {
    setRerender(!rerender);
  }, [branchChargeData]);

  return (
    <div className={tw`w-full overflow-auto min-h-10`}>
      <div className={tw`w-52`}>
        <input
          type="text"
          placeholder="Search"
          value={searchQuery ?? ""}
          onChange={(e) => handleSearch(e?.target?.value)}
          className={tw`border w-full border-1 border-primary focus:outline-none p-1`}
        />
      </div>
      {DeliveryChargeLoading || isRefetching ? (
        <Spinner />
      ) : (
        <div className={tw`w-full`}>
          {branchChargeData?.header?.map((headerItem, hIndex) => {
            const groupCount = Math.floor(
              branchChargeData.body.length / branchChargeData.header.length
            );
            const bodyStart = hIndex * groupCount;
            const bodyEnd = bodyStart + groupCount;

            const productBody = branchChargeData.body.slice(bodyStart, bodyEnd);
            return (
              <div
                key={headerItem.id}
                className={tw`border mb-4 p-2 rounded-md bg-white shadow`}
              >
                <div className={tw``}>
                  <table className={tw`w-full border`}>
                    <thead>
                      <tr>
                        <th
                          className={tw`border px-2 text-left font-semibold`}
                          colSpan={productBody.length + 1}
                        >
                          {headerItem.name}
                        </th>
                      </tr>

                      <tr>
                        <th className={tw`border px-2 whitespace-nowrap`}>
                          Weight (Kg)
                        </th>

                        {productBody.map((group) => (
                          <th
                            key={group.group_id}
                            className={tw`text-center border relative group px-2`}
                          >
                            {group.name}

                            {/* GROUP HOVER DETAILS */}
                            <div
                              className={tw`
              absolute left-1/2 top-full mt-1 w-40 -translate-x-1/2
              rounded-md bg-white shadow-lg border p-2 text-sm z-10
              opacity-0 scale-95 pointer-events-none
              group-hover:opacity-100 group-hover:scale-100 group-hover:pointer-events-auto
              transition-all duration-200
            `}
                            >
                              {group?.countries?.length > 0 ? (
                                <ul className={tw`text-left`}>
                                  {group.countries.map((c, i) => (
                                    <li key={i}>{c}</li>
                                  ))}
                                </ul>
                              ) : (
                                <p className={tw`text-gray-400`}>
                                  No countries
                                </p>
                              )}
                            </div>
                          </th>
                        ))}
                      </tr>
                    </thead>

                    <tbody>
                      {branchChargeData?.non_flat_weight_ranges
                        ?.filter(([start, end]) =>
                          headerItem.name === "Document" ? end <= 1 : true
                        )
                        .map(([start, end], rowIndex) => (
                          <tr key={rowIndex} className={tw`border`}>
                            <td className={tw`border px-2 whitespace-nowrap`}>
                              {start} – {end}
                            </td>

                            {productBody.map((group) => (
                              <td
                                key={group.group_id}
                                className={tw`border px-2`}
                              >
                                <input
                                  type="text"
                                  className={tw`bg-transparent w-full text-center`}
                                  defaultValue={group?.rate?.[rowIndex] ?? ""}
                                  onBlur={(e) =>
                                    handleBranchChargeChange(
                                      group.group_id,
                                      headerItem?.id,
                                      e.target.value,
                                      [start, end]
                                    )
                                  }
                                />
                              </td>
                            ))}
                          </tr>
                        ))}

                      {headerItem.name !== "Document" && (
                        <>
                          <tr>
                            <td
                              className={tw`border font-semibold`}
                              colSpan={productBody.length + 1}
                            >
                              Flat rate per kg
                            </td>
                          </tr>

                          {branchChargeData?.flat_weight_ranges?.map(
                            ([start, end], idx) => {
                              const isLast =
                                idx ===
                                branchChargeData.flat_weight_ranges.length - 1;
                              const overallIndex =
                                idx +
                                branchChargeData.non_flat_weight_ranges.length;

                              return (
                                <tr key={overallIndex} className={tw`border`}>
                                  <td
                                    className={tw`border px-2 whitespace-nowrap`}
                                  >
                                    {isLast
                                      ? `${start} and above`
                                      : `${start} – ${end}`}
                                  </td>

                                  {productBody.map((group) => (
                                    <td
                                      key={group.group_id}
                                      className={tw`border px-2`}
                                    >
                                      <input
                                        type="text"
                                        className={tw`bg-transparent w-full text-center`}
                                        defaultValue={
                                          group?.rate?.[overallIndex] ?? ""
                                        }
                                        onBlur={(e) =>
                                          handleBranchChargeChange(
                                            group.group_id,
                                            headerItem?.id,
                                            e.target.value,
                                            [start, end]
                                          )
                                        }
                                      />
                                    </td>
                                  ))}
                                </tr>
                              );
                            }
                          )}
                        </>
                      )}
                    </tbody>
                  </table>
                </div>
              </div>
            );
          })}
        </div>
      )}
    </div>
  );
};

export default CargoBranchChargeTable;
